import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { FieldTypeOption } from "developer/edit/hooks/useInsertionMenuOptions";
import React from "react";

type FieldListItemProps = {
  option: FieldTypeOption;
  isDrawerOpen: boolean;
  isSelected?: boolean;
  onClick?: (e: any) => void;
};

const FieldListItem: React.FC<FieldListItemProps> = ({
  isDrawerOpen,
  option,
  isSelected,
  onClick,
}) => {
  return (
    <ListItem
      key={option.id}
      disablePadding
      sx={{
        display: "block",
        pl: isDrawerOpen ? 2 : 0,
      }}
    >
      <ListItemButton
        selected={isSelected}
        onClick={onClick}
        sx={{
          minHeight: 40,
          justifyContent: isDrawerOpen ? "initial" : "center",
          px: 2.5,
          borderLeft: (theme) =>
            isSelected ? `4px solid ${theme.palette.primary.main}` : undefined,
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: isDrawerOpen ? 3 : "auto",
            justifyContent: "center",
          }}
        >
          {option.icon}
        </ListItemIcon>
        <ListItemText
          primary={option.label}
          sx={{ opacity: isDrawerOpen ? 1 : 0 }}
        />
      </ListItemButton>
    </ListItem>
  );
};

export default FieldListItem;
